import compaIcon from "../assets/COMPASSIA_ICON.webp";
import React from "react";

export function Compa({ size = 56, radius = 12, className = "" }) {
    // alto proporcional al SVG original
    const height = Math.round(size * 0.75);

    return (
        <img
            src={compaIcon}
            alt="Compa, la capibara"
            width={size}
            height={height}
            className={className}
            style={{
                display: "inline-block",
                width: `${size}px`,
                height: `${height}px`,
                objectFit: "cover",     // para que las esquinas redondas no dejen “huecos”
                borderRadius: radius,   // esquinas redondeadas
                overflow: "hidden",     // asegura el recorte en navegadores quisquillosos
                verticalAlign: "middle",
            }}
            loading="lazy"
            decoding="async"
            draggable={false}
        />
    );
}